import type { ZudokuPlugin } from "zudoku";

const AiScriptPlugin: ZudokuPlugin = {
  getHead: () => {
    return (
      <script
        src="https://cdn.platform.openai.com/deployments/chatkit/chatkit.js"
        async
      />
    );
  },
};

export default AiScriptPlugin;
